"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaTheme = _interopRequireDefault(require("@thinkific/toga-theme"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("./Button.css"));

var _buttonCSS = _interopRequireDefault(require("./buttonCSS"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  && {\n    ", "\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  && {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var cx = _bind["default"].bind(_Button["default"]);

var StyledButton = _styledComponents["default"].button(_templateObject(), _buttonCSS["default"]);

var StyledA = _styledComponents["default"].a(_templateObject2(), _buttonCSS["default"]); // eslint-disable-next-line react/prop-types


var withIcon = function withIcon(_ref) {
  var position = _ref.position;
  return function (WrappedComponent) {
    return function (_ref2) {
      var className = _ref2.className,
          props = _objectWithoutProperties(_ref2, ["className"]);

      var classes = cx(className, {
        'button--icon-left': position === 'left',
        'button--icon-right': position === 'right',
        'button--icon-both': position === 'both'
      });
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({
        className: classes
      }, props));
    };
  };
};

exports.withIcon = withIcon;

var Button = function Button(_ref3) {
  var appearance = _ref3.appearance,
      color = _ref3.color,
      children = _ref3.children,
      className = _ref3.className,
      hasDanger = _ref3.hasDanger,
      isActive = _ref3.isActive,
      isAlternate = _ref3.isAlternate,
      isDark = _ref3.isDark,
      isDisabled = _ref3.isDisabled,
      isUpgrade = _ref3.isUpgrade,
      isHover = _ref3.isHover,
      href = _ref3.href,
      onClick = _ref3.onClick,
      size = _ref3.size,
      props = _objectWithoutProperties(_ref3, ["appearance", "color", "children", "className", "hasDanger", "isActive", "isAlternate", "isDark", "isDisabled", "isUpgrade", "isHover", "href", "onClick", "size"]);

  var Element = href ? StyledA : StyledButton;
  var role = href ? 'button' : null;
  var theme = (0, _react.useContext)(_togaTheme["default"]);
  var appearanceClasses;
  var baseClasses = cx(className, 'button', {
    'button--block': size === 'block',
    'button--x-small': size === 'x-small',
    'button--small': size === 'small',
    'button--small-tight': size === 'small-tight',
    'button--large': size === 'large',
    active: isActive,
    hover: isHover,
    hovered: isHover
  });

  if (isDark) {
    appearanceClasses = cx({
      'button--primary-dark': appearance === 'primary',
      'button--danger-dark': appearance === 'primary' && hasDanger,
      'button--upgrade-dark': appearance === 'primary' && isUpgrade,
      'button--secondary-dark': appearance === 'secondary',
      'button--secondary-danger-dark': appearance === 'secondary' && hasDanger,
      'button--secondary-upgrade-dark': appearance === 'secondary' && isUpgrade,
      'button--knockout-dark': appearance === 'knockout',
      'button--knockout-upgrade-dark': appearance === 'knockout' && isUpgrade,
      'button--knockout-danger-dark': appearance === 'knockout' && hasDanger,
      'button--link-dark': appearance === 'link',
      'button--utility-dark': appearance === 'utility'
    });
  } else {
    appearanceClasses = cx({
      'button--primary': appearance === 'primary',
      'button--danger': appearance === 'primary' && hasDanger,
      'button--upgrade': appearance === 'primary' && isUpgrade,
      'button--secondary': appearance === 'secondary',
      'button--secondary-danger': appearance === 'secondary' && hasDanger,
      'button--secondary-upgrade': appearance === 'secondary' && isUpgrade,
      'button--knockout': appearance === 'knockout',
      'button--knockout-upgrade': appearance === 'knockout' && isUpgrade,
      'button--knockout-danger': appearance === 'knockout' && hasDanger,
      'button--link': appearance === 'link',
      'button--utility': appearance === 'utility',
      'button--accessible-link': appearance === 'accessible-link'
    });
  }

  return /*#__PURE__*/_react["default"].createElement(Element, _extends({
    appearance: appearance,
    className: "".concat(baseClasses, " ").concat(appearanceClasses),
    color: color,
    disabled: isDisabled,
    hasDanger: hasDanger,
    href: href,
    isAlternate: isAlternate,
    isUpgrade: isUpgrade,
    role: role,
    theme: theme,
    onClick: onClick
  }, props), children);
};

Button.propTypes = {
  /** Type of the button */
  appearance: _propTypes["default"].oneOf(['primary', 'secondary', 'knockout', 'link', 'utility', 'accessible-link']),

  /** Content for the button */
  children: _propTypes["default"].node.isRequired,

  /** CSS classes */
  className: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string, _propTypes["default"].object]),

  /** Button color */
  color: _propTypes["default"].string,

  /** Has Danger style */
  hasDanger: _propTypes["default"].bool,

  /** Pass an href prop to make the button an `a` element instead of a `button` */
  href: _propTypes["default"].string,

  /** Has Active state */
  isActive: _propTypes["default"].bool,

  /** Is alternate button style */
  isAlternate: _propTypes["default"].bool,

  /** Change class to the dark version */
  isDark: _propTypes["default"].bool,

  /** Disable button */
  isDisabled: _propTypes["default"].bool,

  /** Has Upgrade content */
  isHover: _propTypes["default"].bool,

  /** Has Hover state */
  isUpgrade: _propTypes["default"].bool,

  /** Size of the button */
  size: _propTypes["default"].oneOf(['x-small', 'small', 'small-tight', 'large', 'block']),

  /** Function to run when the button is clicked */
  onClick: _propTypes["default"].func
};
Button.defaultProps = {
  isActive: false,
  appearance: 'primary',
  className: null,
  color: null,
  hasDanger: false,
  isAlternate: false,
  isDark: false,
  isDisabled: false,
  isUpgrade: false,
  isHover: false,
  href: null,
  size: null,
  onClick: null
};
var _default = Button;
exports["default"] = _default;